export const BasePropsMixin = {
  props: {
    box: {
      type: Object,
      default: () => {}
    }
  }
};
